import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import config from '../../../config/config';
import doctorMImage from './врач.png';
import doctorFImage from './врачиха.png';
import styles from './SelectDoctorStep.module.scss';

function SelectDoctorStep() {
    const navigate = useNavigate();
    const [doctors, setDoctors] = useState<any>(undefined);
    const [isPreload, setPreload] = useState<boolean | null>(true);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>(null);

    const fetch = () => {
        if (config.url_provet_api) {
            setPreload(true);
            axios
                .get(`${config.url_provet_api}doctors`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    setDoctors(response.data.response.rows);
                    setPreload(false);
                })
                .catch(() => {
                    setPreload(null);
                });
        }
    };

    useEffect(() => {
        fetch();
    }, []);

    const handleSubmit = (e: any) => {
        setShowModal(false);
        navigate(`?doctor_id=${modalData.id}`);
        setModalData(null);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalData(null);
        navigate('/online_record');
    };

    if (isPreload === true) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.loadingContainer}>
                        <div className={styles.spinner}></div>
                        <p className={styles.loadingText}>Загружаем список врачей...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (isPreload === null) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.errorContainer}>
                        <h2 className={styles.errorTitle}>Ошибка соединения</h2>
                        <p className={styles.errorText}>Не удалось загрузить список врачей. Пожалуйста, попробуйте
                            позже.</p>
                        <button
                            className={styles.retryButton}
                            onClick={fetch}
                        >
                            Попробовать снова
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <section className={styles.section}>
            <div className={styles.inSection}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <div className={styles.warningBox}>
                            <span className={styles.warningIcon}>⚠️</span>
                            <p className={styles.warningText}>
                                Онлайн-запись действует ТОЛЬКО НА ПРИЕМ<br/>
                                По поводу операций: купирование ушей, стерилизация, кастрация и др., время на выполнение
                                которых превышает 30 минут — записываться по номеру телефона 8 (902) 477-72 52
                            </p>
                        </div>
                    </div>

                    <div className={styles.doctorsGrid}>
                        {doctors && doctors.map((doctor: any) => (
                            <div
                                key={doctor.id}
                                className={styles.doctorCard}
                                onClick={() => {
                                    setShowModal(true);
                                    setModalData(doctor);
                                }}
                                role="button"
                                tabIndex={0}
                                onKeyPress={(e) => e.key === 'Enter' && (() => {
                                    setShowModal(true);
                                    setModalData(doctor);
                                })()}
                            >
                                <div className={styles.doctorImage}>
                                    <img
                                        src={doctor.gender === 'm' ? doctorMImage : doctorFImage}
                                        alt={`${doctor.last_name} ${doctor.first_name}`}
                                        className={styles.avatar}
                                    />
                                </div>

                                <div className={styles.doctorInfo}>
                                    <h3 className={styles.doctorName}>
                                        {doctor.last_name} {doctor.first_name} {doctor.patronymic}
                                    </h3>
                                    <span className={styles.doctorSpecialty}>Ветеринарный врач</span>

                                    {doctor.marks && (
                                        <div className={styles.doctorMarks}>
                                            <span className={styles.marksLabel}>Примечания:</span>
                                            <p className={styles.marksText}>{doctor.marks}</p>
                                        </div>
                                    )}
                                </div>

                                <div className={styles.selectButton}>
                                    <span className={styles.buttonText}>Выбрать</span>
                                    <span className={styles.arrowIcon}>→</span>
                                </div>

                                <div className={styles.cardHoverEffect}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {showModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <div className={styles.modalHeader}>
                            <h2 className={styles.modalTitle}>Подтверждение выбора врача</h2>
                            <button
                                className={styles.modalClose}
                                onClick={handleCloseModal}
                            >
                                ×
                            </button>
                        </div>

                        <div className={styles.modalBody}>
                            <div className={styles.selectedDoctor}>
                                <div className={styles.selectedDoctorImage}>
                                    <img
                                        src={modalData?.gender === 'm' ? doctorMImage : doctorFImage}
                                        alt={`${modalData?.last_name} ${modalData?.first_name}`}
                                        className={styles.selectedAvatar}
                                    />
                                </div>
                                <div className={styles.selectedDoctorInfo}>
                                    <h3 className={styles.selectedDoctorName}>
                                        {modalData?.last_name} {modalData?.first_name} {modalData?.patronymic}
                                    </h3>
                                    <span className={styles.selectedDoctorSpecialty}>Ветеринарный врач</span>
                                </div>
                            </div>

                            <div className={styles.modalWarning}>
                                <span className={styles.modalWarningIcon}>⚠️</span>
                                <p className={styles.modalWarningText}>
                                    Внимание! Если в примечании врача не входят какие-либо процедуры, то Вам могут
                                    отказать в оказании данной услуги
                                </p>
                            </div>

                            {modalData?.marks && (
                                <div className={styles.modalNotes}>
                                    <h4 className={styles.notesTitle}>Примечания врача:</h4>
                                    <p className={styles.notesText}>{modalData.marks}</p>
                                </div>
                            )}
                        </div>

                        <div className={styles.modalFooter}>
                            <button
                                className={styles.confirmButton}
                                onClick={handleSubmit}
                            >
                                Да, записаться к этому врачу
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}

export default SelectDoctorStep;